import { Grid2, Paper } from '@mui/material';

import { useGetCSVInvoicesListQuery } from 'api/hooks/billing/exports';
import { DataGrid } from 'app/components';
import { useTableQuery } from 'utils/hooks/useTableQuery';

import { useCSVColumns } from '../../components/columns';

interface Props {
  search: string;
}
export const CSVInvoicesTab = ({ search }: Props) => {
  const { page, pageSize, sortingModel, handlePaginationChange, handleSortModelChange } =
    useTableQuery({
      defaultSort: [{ field: 'fileName', sort: 'desc' }],
      defaultPageSize: 100,
      sortKey: 'sort_csv',
      paginationKeys: { page: 'page_csv', pageSize: 'pageSize_csv' }
    });

  const { data: invoicesData, isFetching } = useGetCSVInvoicesListQuery({
    params: {
      skip: page * pageSize,
      take: pageSize,
      sort: sortingModel[0]?.field,
      sortOrder: sortingModel[0]?.sort,
      search: search
    }
  });

  return (
    <Grid2 component={Paper} style={{ height: '75vh' }} container size={12}>
      <DataGrid
        style={{ height: '100%', width: '100%' }}
        loading={isFetching}
        columns={useCSVColumns()}
        rows={invoicesData?.data || []}
        disableColumnResize
        disableColumnMenu
        disableRowSelectionOnClick
        rowCount={invoicesData?.count || 0}
        paginationMode="server"
        paginationModel={{ page, pageSize }}
        onPaginationModelChange={handlePaginationChange}
        sortingMode="server"
        sortModel={sortingModel}
        onSortModelChange={handleSortModelChange}
      />
    </Grid2>
  );
};
